import { EventData } from './types';

export const eventsData: EventData[] = [
  {
    id: 'christmas-challenge',
    imageUrl: require('assets/images/marketplace/community-events/christmas-challenge.jpeg'),
  },
  {
    id: 'pizza-night',
    imageUrl: require('assets/images/marketplace/community-events/pizza-night.jpg'),
  },
  {
    id: 'halloween',
    imageUrl: require('assets/images/marketplace/community-events/halloween.jpg'),
  },
  {
    id: 'coloc-cafe',
    imageUrl: require('assets/images/marketplace/community-events/coloc-cafe.jpg'),
  },
  {
    id: 'spring-cleaning',
    imageUrl: require('assets/images/marketplace/community-events/spring-cleaning.jpg'),
  },
  {
    id: 'cupid-housematching',
    imageUrl: require('assets/images/marketplace/community-events/cupid-housematching.jpeg'),
  },
  {
    id: 'sports-challenge',
    imageUrl: require('assets/images/marketplace/community-events/sports-challenge.jpg'),
  },
  {
    id: 'welcoming-sessions',
    imageUrl: require('assets/images/marketplace/community-events/welcoming-sessions.jpg'),
  },
  {
    id: 'pancakes-party',
    imageUrl: require('assets/images/marketplace/community-events/pancakes-party.jpg'),
  },
  {
    id: 'creative-workshops',
    imageUrl: require('assets/images/marketplace/community-events/creative-workshops.jpg'),
  },
  {
    id: 'house-visits',
    imageUrl: require('assets/images/marketplace/community-events/house-visits.jpg'),
  }
];
